module.exports = __webpack_public_path__ + "static/media/sarir.143355c1.ogg";